import React, { useState } from "react";
import { Lightbox } from "react-modal-image";

function ShowAttachment({ attachmentUri, fileName }) {
    const [isOpen, setIsOpen] = useState(false);

    function getFileType(uri) {
        const extension = uri.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(extension)) {
            return 'image';
        } else {
            return 'unknown';
        }
    }

    const handleOpen = (e) => {
        e.preventDefault();
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const normalizeUrl = (uri) => {
        if (!uri) return '#';
        return uri.startsWith('http://') || uri.startsWith('https://') ? uri : `https://${uri}`;
    };

    const fileType = getFileType(attachmentUri);
    if (fileType === 'image') {
        return (
            <>
                <a href="#" onClick={handleOpen}>
                    {fileName}
                </a>
                {isOpen && (
                    <Lightbox
                        medium={attachmentUri}
                        large={attachmentUri}
                        alt="Image Attachment"
                        onClose={handleClose}
                    />
                )}
            </>
        );
    }
    else {
        return (
            <>
                <a href={normalizeUrl(attachmentUri)} target="_blank" rel="noopener noreferrer">
                    {fileName}
                </a>
            </>
        );
    }
}

export default ShowAttachment;
